var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bar",class:{
    'cont-before': _vm.segment.continuesBefore,
    'cont-after': _vm.segment.continuesAfter,
    active: _vm.active
  },style:({
    gridColumn: ((_vm.segment.startCol + 1) + " / " + (_vm.segment.endCol + 2)),
    gridRow: _vm.segment.lane + 2
  }),attrs:{"type":"button","title":_vm.segment.event.title},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.segment.event, $event.currentTarget)}}},[_c('span',{staticClass:"bar-title"},[_vm._v(_vm._s(_vm.segment.event.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }